import { Tag } from '..';
import type { TTagProps } from '../types/TProps';

export const TagInfoRounded = ({ className = '', ...props }: TTagProps) => (
  <Tag {...props} className={['tag--info-rounded', className].filter(Boolean).join(' ')} />
);
